module.exports = __webpack_public_path__ + "img/fig09.651cadb3.jpg";